<footer *ngIf="!newFooter" class="app-footer  pb-80 "
    [ngStyle]="{'font-family': settingsData.font_family ? settingsData.font_family : null,
    'background-color':settingsData.footer_bg_primary_color  }">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-5 col-lg-6 mb-2">

                <div class="g-txt mb-3" *ngIf="performer_details"
                [ngStyle]="{'color': settingsData.footer_font_secondary_color ? settingsData.footer_font_secondary_color : null }">
                    &copy; {{copyRightYear}} {{performer_details.organization_name}}. All rights reserved.
                </div>
                <ng-container class="d-inline" *ngIf="deviceType == 'browser' && performer_details">
                    <a [href]=performer_details.android_app_link target="_blank"
                        *ngIf="performer_details.android_app_link"><img [src]="assets_url + 'website/homepage/googleplay.png'"
                            width="130px"></a>
                    <a [href]=performer_details.ios_app_link target="_blank" *ngIf="performer_details.ios_app_link"><img
                            [src]="assets_url + 'website/homepage/appstore.png'" width="130px" class="ml-2"></a>
                </ng-container>
            </div>
            <div class="col-6 col-md-2 col-lg-2 mb-2">
                <p  [ngStyle]="{'color': settingsData.footer_font_primary_color ? settingsData.footer_font_primary_color : null }">
                    Company
                </p>
                <div class="pointer">
                    <a (click)="goToRespectiveScreen('contactus')" [ngStyle]="{'color': settingsData.footer_font_secondary_color ? settingsData.footer_font_secondary_color : null }">
                        Contact Us
                    </a>
                </div>
            </div>
            <div class="col-6 col-md-3 col-lg-2 mb-2 pl-0">
                <p class="ic-text-info" [ngStyle]="{'color': settingsData.footer_font_primary_color ? settingsData.footer_font_primary_color : null }">
                    Legal
                </p>
                <div class="pointer d-inline">
                    <a (click)="goToRespectiveScreen('privacypolicy')" [ngStyle]="{'color': settingsData.footer_font_secondary_color ? settingsData.footer_font_secondary_color : null }">Privacy Policy</a><br>
                    <a (click)="goToRespectiveScreen('cookiepolicy')" [ngStyle]="{'color': settingsData.footer_font_secondary_color ? settingsData.footer_font_secondary_color : null }">Cookie Policy</a><br>
                    <a (click)="goToRespectiveScreen('termsandconditions')" [ngStyle]="{'color': settingsData.footer_font_secondary_color ? settingsData.footer_font_secondary_color : null }">Terms of Service</a>
                </div>
            </div>
            <!-- <div class="col-12 col-md-2 col-lg-2 pointer"> -->
                <!-- <img [src]="assets_url + 'Powered by- Arevea.svg'" width="100" class="mb-3" (click)="redirectTo()"> -->
                <!-- <span class="mb-3" (click)="redirectTo()" ><app-svg [icon]="'powered-by-bigbee'"></app-svg></span> -->
            <div class="col-12 col-md-2 col-lg-2" *ngIf="logoUrl">
                <img class="mb-3" [src]="logoUrl" alt="" style="max-width: 100%; max-height: 80px; object-fit: contain;">
            </div>
        </div>
    </div>
</footer>

<app-ic-footer-v2 *ngIf="newFooter" [settingsData]="settingsData" [performerDetails]="performer_details"
    [deviceType]="deviceType" [channelName]="channelName"
    [reserveBottomSpace]="is_show_musicPlayer" (navigate)="goToRespectiveScreen($event)"></app-ic-footer-v2>
